import { IPageLayoutType } from "../../types/pageLayoutTypes";

export const useReportDetails = () => {
  const rowData = [
    {
      id: "R9002",
      badge: "New",
      accessionid: "9002",
      sampleid: "S104, S105, S106",
      date: "05-05-2024",
      reporter: "Vendor#456",
      isNew: true,
    },
    {
      id: "R9003",
      badge: "Updated",
      accessionid: "9003",
      sampleid: "S104, S105, S106",
      date: "05-05-2024",
      reporter: "Vendor#456",
      isUpdated: true,
    },
    {
      id: "R9004",
      badge: "",
      accessionid: "9004",
      sampleid: "S104, S105, S106",
      date: "05-05-2024",
      reporter: "Vendor#456",
    },
    {
      id: "R9005",
      badge: "",
      accessionid: "9003",
      sampleid: "S104, S105, S106",
      date: "05-05-2024",
      reporter: "Vendor#456",
    },
    {
      id: "R9006",
      badge: "",
      accessionid: "9004",
      sampleid: "S104, S105, S106",
      date: "05-05-2024",
      reporter: "Vendor#456",
    },
  ];
  const reportsContentJson: IPageLayoutType[] = [
    {
      title: "Report",
      content: [
        {
          label: "Report ID",
          value: "R9002",
          size: {
            mediumScreen: 6,
            extraSmallScreen: 6,
          },
        },
        {
          label: "Sample ID",
          value: "S104, S105, S106",
          size: {
            mediumScreen: 6,
            extraSmallScreen: 6,
          },
        },
        {
          label: "Accession ID",
          value: "9002",
          size: {
            mediumScreen: 6,
            extraSmallScreen: 6,
          },
        },
        {
          label: "Patient ID",
          value: "3333-222",
          size: {
            mediumScreen: 6,
            extraSmallScreen: 6,
          },
        },
        {
          label: "Study  ID",
          value: "ONC-NSCLC-2024-01",
          size: {
            mediumScreen: 6,
            extraSmallScreen: 6,
          },
        },
        {
          label: "Report Date",
          value: "05-05-2024",
          size: {
            mediumScreen: 6,
            extraSmallScreen: 6,
          },
        },
        {
          label: "Reporter",
          value: "CL1001",
          size: {
            mediumScreen: 6,
            extraSmallScreen: 6,
          },
        },
        {
          label: "PDF",
          value: "Attachement Icon",
          size: {
            mediumScreen: 6,
            extraSmallScreen: 6,
          },
        },
      ],
    },
  ];
  return {
    rowData,
    reportsContentJson,
  };
};
